import type { Task } from "@dune/types";
import { DataTable } from "@dune/ui";
import React, { useMemo } from "react";
import { useTaskActions } from "../../../../stores/task.store";
import { tasksColumns } from "./tasksColumns";
import { useMe } from "../../../../api/queries/users.queries";

interface TasksTabProps {
	tasks?: Task[];
	isLoading?: boolean;
	error?: unknown;
}

const TasksTab: React.FC<TasksTabProps> = ({
	tasks,
	isLoading = false,
	error,
}) => {
	const { selectTask } = useTaskActions();
	const { me: user } = useMe();
	const handleRowClick = (task: Task) => {
		selectTask(task.id.toString());
	};

	const tasksData = useMemo(() => {
		return tasks || [];
	}, [tasks]);

	if (error) return <div>Erreur lors du chargement des tâches.</div>;

	const isDuneRole = user?.role === "DUNE";

	return (
		<div className="h-full">
			<div className="flex items-center justify-between mb-2 w-full">
				<h2 className="text-lg font-semibold">Tâches</h2>
			</div>
			<DataTable
				data={tasksData}
				columns={tasksColumns}
				noResultsText="Aucune tâche trouvée"
				isLoading={isLoading}
				onRowClick={isDuneRole ? handleRowClick : undefined}
				variant="static-clean"
			/>
		</div>
	);
};

export default TasksTab;
